import React, { useState, useRef, useEffect } from "react";
import InfoModal from "../Modal/InfoModal";
import i18next from "i18next";
import { useSelector } from "react-redux";

interface Props {
  text: string;
  store: any;
}

const FullWidthStoreDescription: React.FC<Props> = ({ text, store }) => {
  const [isInfo, setIsInfo] = useState(false);
  const [clampedText, setClampedText] = useState("");
  const [isReadMoreShow, setIsReadMoreShow] = useState(false);
  const containerRef = useRef<HTMLParagraphElement | null>(null);

  const [lang] = useState(i18next.language);
  const { translations }: any = useSelector(
    (state: any) => state?.languageData
  );

  useEffect(() => {
    if (!text || !containerRef.current) return;

    const computeClamp = () => {
      const element = containerRef.current!;
      const width = element.offsetWidth;

      const tester = document.createElement("div");
      const style = getComputedStyle(element);

      tester.style.position = "absolute";
      tester.style.visibility = "hidden";
      tester.style.width = `${width-15}px`;
      tester.style.fontSize = style.fontSize;
      tester.style.lineHeight = style.lineHeight;
      tester.style.fontFamily = style.fontFamily;
      tester.style.whiteSpace = "normal";
      tester.style.wordBreak = "break-word";
      tester.style.display = "-webkit-box";
      tester.style.webkitLineClamp = "2";
      tester.style.webkitBoxOrient = "vertical";
      tester.style.overflow = "hidden";

      document.body.appendChild(tester);

      let content = text;
      tester.innerText = content;

      const isOverflowing = tester.scrollHeight > tester.clientHeight;
      setIsReadMoreShow(isOverflowing);

      while (
        tester.scrollHeight > tester.clientHeight &&
        content.length > 0
      ) {
        content = content.slice(0, -1);
        tester.innerText = content + "...";
      }

      setClampedText(content);
      document.body.removeChild(tester);
    };

    computeClamp();
    window.addEventListener("resize", computeClamp);
    return () => window.removeEventListener("resize", computeClamp);
  }, [text]);

  return (
    <>
      <div className="w-full min-w-0">
        <p
          ref={containerRef}
          className="w-full text-sm text-gray-600 leading-snug"
        >
          {clampedText}
          {isReadMoreShow && (
            <span
              className="cursor-pointer text-primary ml-1"
              onClick={() => setIsInfo(true)}
            >
              ...
            </span>
          )}
        </p>
      </div>

      {isInfo && (
        <InfoModal
          item={{ name: store?.store_name, ...store }}
          isInfo={isInfo}
          setIsInfo={setIsInfo}
          lang={lang}
          translations={translations}
        />
      )}
    </>
  );
};

export default FullWidthStoreDescription;
